module.exports = __webpack_public_path__ + "img/walter.ee0330a8.jpg";